import {Observable} from 'rxjs';
import {HttpResponse} from '@angular/common/http';
import {ServicesService} from '../../rest-service/services.service';
import {User} from '../dto/User';
import {Registry} from '../dto/Registry';
import {License} from '../dto/License';
import {TypeTwoFa} from '../dto/TypeTwoFa';


export abstract class UserRestService<U extends User> {

  public readonly BASE_URL: string = 'user';
  public readonly LOGOUT_URL: string = 'logout';

  protected abstract services: ServicesService;

  getUser(): Observable<HttpResponse<U>> {
    return this.services.get<U>(
      this.BASE_URL,
      {},
      'Impossibile effettuare l\'accesso! Nome utente o password errati.');
  }

  getRegistry(): Observable<HttpResponse<Registry>> {
    return this.services.get<Registry>(
      this.BASE_URL + '/registry',
      {},
      'Impossibile recuperare le tue informazioni!');
  }

  getLicense(): Observable<HttpResponse<License[]>> {
    return this.services.get<License[]>(
      this.BASE_URL + '/license',
      {},
      'Impossibile recuperare la licenza d\'uso!');
  }

  acceptLicense(): Observable<HttpResponse<void>> {
    return this.services.post<void>(
      this.BASE_URL + '/acceptLicense',
      {},
      'Non è stato possibile accettare la licenza d\'uso! Riprovare più tardi.');
  }

  changeUsername(newUsername: string, username: string, password: string): Observable<HttpResponse<void>> {
    return this.services.put<void>(
      this.BASE_URL + `/changeUsername?newUsername=${newUsername}&username=${username}&password=${password}`,
      {},
      'Credenziali errate! Impossibile aggiornare lo username!');
  }

  changePassword(oldPassword: string, newPassword: string): Observable<HttpResponse<void>> {
    return this.services.put<void>(
      this.BASE_URL + `/changePassword?oldPassword=${oldPassword}&newPassword=${newPassword}`,
      {},
      'Password errata! Impossibile aggiornare la password!');
  }

  saveRegistry(registry: Registry): Observable<HttpResponse<Registry>> {
    return this.services.post<Registry>(
      this.BASE_URL + '/saveRegistry',
      registry,
      'Impossibile aggiornare i dati del profilo!');
  }

  send(mail): Observable<HttpResponse<void>> {
    return this.services.post<void>(
      this.BASE_URL + '/sendMail',
      mail,
      'Impossibile inviare il messaggio!');
  }

  usernameAlreadyExists(username: string): Observable<HttpResponse<void>> {
    return this.services.get<void>(
      'user/alreadyExists',
      {username},
      'Username già esitente!');
  }

  setTwoFaType(typeTwoFa: TypeTwoFa): Observable<HttpResponse<void>> {
    return this.services.put<void>(
      this.BASE_URL + `/changeTwoFaMethod?type2fa=${typeTwoFa}`,
      {},
      'Non è stato possibile salvare la metodologia di autenticazione! Riprova più tardi.');
  }

  quit(): Observable<HttpResponse<void>> {
    return this.services.logout(
      this.LOGOUT_URL,
      'Si è verificato un problema durante l\'uscita dall\'applicazione!');
  }

  lock(): Observable<HttpResponse<void>> {
    return this.services.lock(
      this.LOGOUT_URL,
      'Si è verificato un problema durante l\'uscita dall\'applicazione!');
  }

  authTwoFaRequest(token: string, confirmCode: string, saveDeviceTwoFa: boolean): Observable<HttpResponse<U>> {
    return this.services.auth(token, 'auth', {confirmCode, saveDeviceTwoFa});
  }

  renewTwoFaCodeRequest(token: string): Observable<HttpResponse<U>> {
    return this.services.auth(token, 'auth/renew', {});
  }

  login(username, password): Observable<HttpResponse<U>> {
    return this.services.login<U>(
      'login',
      {
        username,
        password
      });
  }

}
